import React, { useState } from 'react';

import MessagesMessageList from './MessagesMessageList';
import MessagesMessageView from './MessagesMessageView';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';
import permissions from '../../permissionsList';
import AccessControl from '../../AccessControl';

function MessageCenter() {
  const [openMessage, setOpenMessage] = useState({
    msgType: '',
    msgId: '',
    detailsId: '',
  });

  /**
   * Function to set which message has been selected to view the details
   * @param {object} message - The message information for setting the value of local state for the selected message
   * @fires setState - Updates state with the information about the selected message
   */
  function viewMessage(message) {
    setOpenMessage({
      msgType: message.msgType,
      msgId: message.msgId,
      detailsId: message.detailsId,
    });
  }

  let msgDisplay;
  if (openMessage.msgId !== '') {
    msgDisplay = (
      <MessagesMessageView
        openMessage={openMessage}
        data-test="message-full-view"
      />
    );
  }

  return (
    <React.Fragment>
      <FormattedMessage
        id="messaging.browserTabInfo"
        defaultMessage="Messaging | SARA"
        description="Messaging browser tab">
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.navBar.messaging}
        permissionMessage={true}>
        <div className="message-center" data-test="message-center">
          <MessagesMessageList
            openMessage={openMessage}
            viewMessage={viewMessage}
          />
          {msgDisplay}
        </div>
      </AccessControl>
    </React.Fragment>
  );
}

export default MessageCenter;
